import { ChevronDown } from '@dreamstack/icons/src/icon-components/ChevronDown'
import { ChevronUp } from '@dreamstack/icons/src/icon-components/ChevronUp'
import { Listbox, Transition } from '@headlessui/react'
import map from 'lodash/map'
import type { FunctionComponent } from 'react';
import { Fragment } from 'react'
import { cn } from '@dreamstack/util/src/cn'
import { BodyText } from './Texts'

export type OptionsProps = {
  id: number
  name: string | number
  value: number
}

export const DropdownButton: FunctionComponent<React.PropsWithChildren<{
  selectValue: OptionsProps
  setSelectValue: React.Dispatch<React.SetStateAction<OptionsProps>>
  options: OptionsProps[]
  label?: string
  partnerDropdownActiveValue?: { value: number; partnerIsMax: boolean }
}>> = ({
  selectValue,
  setSelectValue,
  options,
  label,
  partnerDropdownActiveValue,
}) => {
  const isMax = partnerDropdownActiveValue?.partnerIsMax

  return (
    <div className="w-full">
      <Listbox by="value" value={selectValue} onChange={setSelectValue}>
        {({ open }) => (
          <div className="relative">
            {label && (
              <Listbox.Label className="text-left text-xs text-accentroGray-500">
                {label}
              </Listbox.Label>
            )}

            <Listbox.Button className="w-full py-px-8 px-px-20 text-left bg-accentroGray-50 relative cursor-default flex flex-row justify-between">
              <BodyText> {selectValue.name}</BodyText>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 flex-shrink-0">
                {open ? (
                  <ChevronUp className="h-px-32 w-px-32 text-gray-400" />
                ) : (
                  <ChevronDown className="h-px-32 w-px-32 text-gray-400" />
                )}
              </span>
            </Listbox.Button>
            <Transition
              leave="transition ease-in duration-500"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto bg-white py-1 z-10 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {map(options, (option) => (
                  <Listbox.Option
                    //   @ts-ignore
                    as={Fragment}
                    key={option.id}
                    value={option}
                    disabled={
                      partnerDropdownActiveValue
                        ? isMax
                          ? option.value > partnerDropdownActiveValue?.value
                          : option.value < partnerDropdownActiveValue?.value
                        : false
                    }
                  >
                    {({ active, disabled }) => (
                      <li
                        className={cn(
                          'relative py-2 px-3 font-semibold',
                          active ? 'bg-accentroGray-50' : 'bg-white text-black',
                          disabled &&
                            'text-accentroGray-200 bg-accentroGray-50 cursor-not-allowed'
                        )}
                      >
                        <BodyText>{option.name}</BodyText>
                      </li>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        )}
      </Listbox>
    </div>
  )
}
